import { createContext, useState, useEffect } from 'react';
import { useLazyGetUsersQuery } from '../api/service';
import useLocalStorage from '../hooks/useLocalStorage';

const StreakContext = createContext();

const StreakProvider = ({ children }) => {
	const [userId, setUserId] = useState(null);
	const [user, setUser] = useState(null);
	const { storage: userData } = useLocalStorage('userData');
	const { storage: userStorage, removeLocalStorage, addLocalStorage } = useLocalStorage('user');
	const [getUser, { data }] = useLazyGetUsersQuery();
	const [streak, setStreak] = useState(null);
	const [openStreakModal, setOpenStreakModal] = useState(false);

	useEffect(() => {
		fetchUser();
	}, [userId]);

	useEffect(() => {
		if (data) {
			setStreak(data.Streak);
			updateUser(data);
		}
	}, [data]);

	const fetchUser = () => {
		if (userId) {
			getUser(userId);
		} else if (userData) {
			setUserId(userData?.userId);
			getUser(userData?.userId);
		}
	};

	const updateUser = (user) => {
		removeLocalStorage();
		addLocalStorage(user);
		setUser(user);
	};

	const refetchStreak = () => {
		fetchUser();
	};

	return (
		<StreakContext.Provider
			value={{
				userId,
				setUserId,
				user,
				updateUser,
				refetchStreak,
				streak,
				openStreakModal,
				setOpenStreakModal
			}}
		>
			{children}
		</StreakContext.Provider>
	);
};

export { StreakProvider, StreakContext };
